import React, { FC } from 'react';
import { ReactComponent as ExcelFile } from '../../../assets/ExportButtons/ExcelFile.svg';

export const ExcelFileIcon: FC = () => <ExcelFile />;
